export default __webpack_public_path__ + "static/media/JioSaavnLogoWhite.6be6877b.png";